export const settingsInitialData = (formData?: string) => {
  let result = { questions: {}, answers: {} }

  if (formData) {
    const companyData = JSON.parse(formData)
    result = {
      ...result,
      answers: {
        ...result.answers,
        ...Object.fromEntries(Object.entries(companyData).filter(([_, value]) => value !== '')),
      },
    }
  }
  return result
}
